/**
 * Señal compartida: hay una escena a sangre ocupando la ventana.
 *
 * La cabecera se dibuja en hueso y sin fondo cuando está sobre imagen oscura a
 * sangre. En el hero eso lo decide ella sola (basta con no haber hecho scroll),
 * pero el scroll de bodas aparece a media página, así que necesita avisar.
 *
 * Es un store mínimo en lugar de contexto porque quien lo escribe lo hace desde
 * un callback de ScrollTrigger, fuera del ciclo de render de React, y quien lo
 * lee sólo necesita volver a pintar cuando cambia de verdad.
 */

let activa = false;
const suscriptores = new Set<() => void>();

export function setEscenaPlena(valor: boolean) {
  if (valor === activa) return;
  activa = valor;
  suscriptores.forEach((avisar) => avisar());
}

export function suscribirEscenaPlena(avisar: () => void) {
  suscriptores.add(avisar);
  return () => {
    suscriptores.delete(avisar);
  };
}

export const leerEscenaPlena = () => activa;

/** En servidor nunca hay escena ocupando la ventana. */
export const leerEscenaPlenaServidor = () => false;
